<template>
  <section class="section-base">
    <div class="section-base__title">Изменился статус вашего заявления №234</div>
    <div class="message">
      <div class="message__text">от Нотариуса н.о. Самарской области</div>
      <div class="message__text">17.11.2020</div>
      <div class="message__body">
        Уважаемый Карпович Андрей Алексеевич,
        ваше заявление №23 было отложено.
        <br>
        Форма заявления "Заявление о совершении исполнительной надписи" заполнена некорректно
      </div>
      <div class="error-field">
        <div class="title">Вам необходимо исправить следующие поля:</div>
        <div class="field">Причина смены кредитора</div>
      </div>
      <div>
        <v-btn depressed color="primary" class="button-base">Перейти к форме заявления</v-btn>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "NotificationDetail"
}
</script>

<style scoped lang="scss">
.button-base {
  margin-top: 50px;
}

.message {
  display: flex;
  flex-direction: column;

  &__text {
    color: $color-dark;
    font-size: $font-size-small;
  }

  &__body {
    color: black;
    margin: 35px 0 0;
  }
}

.error-field {
  margin-top: 20px;

  & .title {
    font-weight: 600;
  }

  & .field {
    padding: 10px 0;
  }
}
</style>
